// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__3VtpF","name":"Affair_name__KiM7p","closeButton":"Affair_closeButton__eayDu"};